import { ModelNumberLocationContent } from '../components/ModelNumberLocation/ModelNumberLocation';
import comboLaundryImg from '../assets/images/modelNumberLocation/combo-laundry.avif';
import compactorImg from '../assets/images/modelNumberLocation/compactor.avif';
import cooktopImg from '../assets/images/modelNumberLocation/cooktop.avif';
import dishwasherImg from '../assets/images/modelNumberLocation/dishwasher.avif';
import disposerImg from '../assets/images/modelNumberLocation/disposer.avif';
import dryerImg from '../assets/images/modelNumberLocation/dryer.avif';
import microwaveImg from '../assets/images/modelNumberLocation/microwave.avif';
import rangeImg from '../assets/images/modelNumberLocation/range.avif';
import refrigeratorImg from '../assets/images/modelNumberLocation/refrigerator.avif';
import wallOvenImg from '../assets/images/modelNumberLocation/wall-oven.avif';
import washerImg from '../assets/images/modelNumberLocation/washer.avif';

export const modelNumberLocationOptions = [
  { value: 'comboLaundry', label: 'Combo Laundry' },
  { value: 'compactor', label: 'Compactor' },
  { value: 'cooktop', label: 'Cooktop' },
  { value: 'dishwasher', label: 'Dishwasher' },
  { value: 'disposer', label: 'Disposer' },
  { value: 'dryer', label: 'Dryer' },
  { value: 'microwave', label: 'Microwave' },
  { value: 'range', label: 'Range' },
  { value: 'refrigerator', label: 'Refrigerator' },
  { value: 'wallOven', label: 'Wall Oven' },
  { value: 'washer', label: 'Washer' },
];

const BRAND_EXCLUDED_LOCATIONS: Record<string, string[]> = {
  khaid: ['comboLaundry', 'dryer', 'washer'],
};

export const getModelNumberLocationOptions = (brandCode?: string) => {
  const code = (brandCode || (import.meta.env.VITE_BRAND_CODE as string) || '')
    .trim()
    .toLowerCase();

  const excluded = BRAND_EXCLUDED_LOCATIONS[code] || [];
  return modelNumberLocationOptions.filter((opt) => !excluded.includes(opt.value));
};

export const modelNumberLocationContent: ModelNumberLocationContent = {
  comboLaundry: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: [
          'Inside left rear corner of washer top (door open)',
          'On cabinet, inside right rear corner of washer top (door open)',
        ],
        imageSrc: comboLaundryImg,
      },
    ],
  },
  compactor: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: ['Inside', 'On rim'],
        imageSrc: compactorImg,
      },
    ],
  },
  cooktop: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: ['Inside the burner box', 'Underneath on the bottom'],
        imageSrc: cooktopImg,
      },
    ],
  },
  dishwasher: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: ['Upper left corner of the frame', 'Underside of the control panel'],
        imageSrc: dishwasherImg,
      },
    ],
  },
  disposer: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: ['On the bottom'],
        imageSrc: disposerImg,
      },
    ],
  },
  dryer: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: [
          'On the upper left of the cabinet (in the back)',
          'Inside on the back frame (door open)',
          'Inside the door',
          'Behind the access panel (gas dryers only)',
        ],
        imageSrc: dryerImg,
      },
    ],
  },
  microwave: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: [
          'Back of the microwave',
          'Upper left of the cavity',
          'Left side of the control panel (door open)',
          'Right side of the base frame (door open)',
          'Front of the base frame (door open)',
        ],
        imageSrc: microwaveImg,
      },
    ],
  },
  range: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: ['Inside the burner box', 'Underneath on the bottom'],
        imageSrc: rangeImg,
      },
    ],
  },
  refrigerator: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: [
          'Top left side of the food compartment',
          'Top front of the food compartment',
          'Food liner (upper right side of the crisper pan)',
        ],
        imageSrc: refrigeratorImg,
      },
    ],
  },
  wallOven: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: ['Lower left side of the frame (door open)'],
        imageSrc: wallOvenImg,
      },
    ],
  },
  washer: {
    leadText: 'Model number locations may vary. Common locations include:',
    appliances: [
      {
        locations: [
          'On the back, behind the control panel',
          'Inside the washer lid, right bottom corner',
          'On the back on the base frame to the left',
        ],
        imageSrc: washerImg,
      },
    ],
  },
};
